import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function About() {
  const { t } = useTranslation();

  const toArray = (v) => (Array.isArray(v) ? v : []);

  const overviewRaw = String(t("company.what_sets_us_apart") || "");
  const overviewParts = overviewRaw.split(/\s*\n\s*/g).filter(Boolean);

  const services = toArray(t("company.services", { returnObjects: true }));
  const serviceBlurbs = toArray(
    t("home.services_blurbs", { returnObjects: true })
  );
  const serviceIcons = toArray(
    t("company.services_icons", { returnObjects: true })
  );

  const approachTitles = toArray(
    t("about.approach_points", { returnObjects: true })
  );
  const approachDescs = toArray(
    t("about.approach_desc", { returnObjects: true })
  );

  /*const facts = [
    { label: t("company.industry"), icon: "industry" },
    { label: t("company.company_size"), icon: "team" },
    { label: t("company.hq"), icon: "hq" },
    { label: t("company.founded"), icon: "calendar" },
    { label: t("company.linkedIn_members"), icon: "linkedin" },
  ];*/

  const Icon = ({ name, className = "h-5 w-5" }) => {
    switch (name) {
      case "bolt":
        return (
          <svg viewBox="0 0 24 24" fill="none" className={className}>
            <path
              d="M13 2L3 14h7l-1 8 12-16h-8l0-6z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case "advisory":
        return (
          <svg viewBox="0 0 24 24" fill="none" className={className}>
            <path
              d="M4 19h16M4 5h16M8 9h8M8 15h5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M18 14l2 2-5 5h-2v-2l5-5z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case "globe":
        return (
          <svg viewBox="0 0 24 24" fill="none" className={className}>
            <circle
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="2"
            />
            <path
              d="M2 12h20M12 2c3 3.5 3 16.5 0 20M5 5c4 2 10 2 14 0"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        );
      case "industry":
        return (
          <svg viewBox="0 0 24 24" fill="none" className={className}>
            <path
              d="M3 21h18M5 21V10l6 4V10l6 4V7h2v14"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case "team":
        return (
          <svg viewBox="0 0 24 24" fill="none" className={className}>
            <path
              d="M16 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm10 14v-2a4 4 0 0 0-3-3.87M17 3a4 4 0 0 1 0 8"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case "hq":
        return (
          <svg viewBox="0 0 24 24" fill="none" className={className}>
            <path
              d="M3 21h18M6 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16M9 9h6M9 13h6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case "calendar":
        return (
          <svg viewBox="0 0 24 24" fill="none" className={className}>
            <path
              d="M16 2v4M8 2v4M3 9h18M5 21h14a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case "linkedin":
        return (
          <svg viewBox="0 0 24 24" fill="none" className={className}>
            <path
              d="M6 9v10M6 5v.01M10 19v-6a3 3 0 1 1 6 0v6M4 21h16"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      default:
        return null;
    }
  };

  const SmallIcon = ({ name }) => {
    const base = "h-5 w-5";
    switch (name) {
      case "dev":
        return (
          <svg viewBox="0 0 24 24" fill="none" className={base}>
            <path
              d="M8 16l-4-4 4-4M16 8l4 4-4 4M14 4l-4 16"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case "ai":
        return (
          <svg viewBox="0 0 24 24" fill="none" className={base}>
            <path
              d="M12 3v3M12 18v3M4.22 4.22l2.12 2.12M17.66 17.66l2.12 2.12M3 12h3M18 12h3M4.22 19.78l2.12-2.12M17.66 6.34l2.12-2.12"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <circle
              cx="12"
              cy="12"
              r="4"
              stroke="currentColor"
              strokeWidth="2"
            />
          </svg>
        );
      case "clevel":
        return (
          <svg viewBox="0 0 24 24" fill="none" className={base}>
            <path
              d="M4 22v-2a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v2"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <circle
              cx="12"
              cy="10"
              r="4"
              stroke="currentColor"
              strokeWidth="2"
            />
          </svg>
        );
      case "marketing":
        return (
          <svg viewBox="0 0 24 24" fill="none" className={base}>
            <path
              d="M3 10l12-7v18L3 14V10z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinejoin="round"
            />
            <path
              d="M21 12a3 3 0 0 1-3 3"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        );
      case "hr":
        return (
          <svg viewBox="0 0 24 24" fill="none" className={base}>
            <path
              d="M16 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <circle cx="9" cy="8" r="4" stroke="currentColor" strokeWidth="2" />
            <path
              d="M20 21v-2a4 4 0 0 0-3-3.87M17 3a4 4 0 1 1 0 8"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        );
      case "legal":
        return (
          <svg viewBox="0 0 24 24" fill="none" className={base}>
            <path
              d="M12 3l8 4-8 4-8-4 8-4z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinejoin="round"
            />
            <path
              d="M4 11l8 4 8-4M4 17l8 4 8-4"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinejoin="round"
            />
          </svg>
        );
      case "qa":
        return (
          <svg viewBox="0 0 24 24" fill="none" className={base}>
            <path
              d="M9 11l2 2 4-4"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <rect
              x="3"
              y="3"
              width="18"
              height="14"
              rx="2"
              ry="2"
              stroke="currentColor"
              strokeWidth="2"
            />
            <path
              d="M7 21h10"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        );
      default:
        return null;
    }
  };

  const stories = [
    {
      title: "2 Senior Angular Developer roles — open for 9+ months",
      result: "Closed by us in 3 weeks.",
    },
    {
      title:
        "Two teams of 10 developers for a fast-scaling startup needing urgent hires",
      result: "Closed by us in 1 month.",
    },
    {
      title:
        "3 Dutch-speaking Customer Support roles — night shifts, very low budget, considered “impossible”",
      result: "Closed by us in 3 weeks.",
    },
    {
      title:
        "Country Manager — helped a Romanian company open their first office in Budapest, Hungary",
      result: "Closed by us in 1 month.",
    },
  ];

  const expertise = [
    {
      icon: "dev",
      title: "Development & IT",
      roles: "Developers, DevOps, IT specialists",
    },
    {
      icon: "ai",
      title: "AI / ML",
      roles: "Data Scientists, Data Engineers, Data Architects",
    },
    {
      icon: "clevel",
      title: "Management & C-Level",
      roles: "Executives, Team Leads, Directors, Architects, Country Managers",
    },
    {
      icon: "marketing",
      title: "Marketing & Sales",
      roles: "Marketing, PPC, Affiliate, Sales Teams",
    },
    {
      icon: "hr",
      title: "HR & Customer Support",
      roles: "Recruiter, HR Manager, Customer Service",
    },
    {
      icon: "legal",
      title: "Legal & Accounting",
      roles: "Legal Advisor, Finance Director, Accountant",
    },
    { icon: "qa", title: "QA", roles: "Manual & Automation Testing" },
  ];

  return (
    <section className="max-w-6xl mx-auto px-4 py-12 space-y-10">
      <header className="rounded-2xl border border-neutral-800 bg-white/5 backdrop-blur-sm p-6 md:p-8">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <h1 className="text-4xl md:text-5xl font-extrabold">
            {t("about.title")}
          </h1>

          <div className="flex gap-3 shrink-0">
            <Link
              to="/#contact-info"
              className="px-5 py-3 rounded-full bg-white text-black font-bold"
            >
              {t("home.cta_contact")}
            </Link>
            <Link
              to="/team"
              className="px-5 py-3 rounded-full border border-neutral-700 font-bold hover:bg-white hover:text-black transition"
            >
              {t("team.title")}
            </Link>
          </div>
        </div>
      </header>

      <section className="rounded-2xl border border-neutral-800 p-6">
        <h2 className="text-2xl md:text-3xl font-extrabold mb-3">
          {t("company.overview_heading")}
        </h2>
        <div className="relative pl-4 md:pl-5">
          <span
            className="absolute left-0 top-1 bottom-1 w-1 rounded-full bg-white/10"
            aria-hidden="true"
          />
          {overviewParts.map((p, i) => (
            <p
              key={i}
              className={
                i === 0
                  ? "text-base md:text-lg font-semibold leading-relaxed"
                  : "text-neutral-300 mt-2"
              }
            >
              {p}
            </p>
          ))}
        </div>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl md:text-3xl font-extrabold">
          {t("home.services_title")}
        </h2>
        <div className="grid md:grid-cols-2 gap-4">
          {services.map((s, i) => {
            const iconSrc =
              serviceIcons[i] || "/services/career-counselling.svg";
            const blurb = serviceBlurbs[i] || t("home.service_default_blurb");
            return (
              <div
                key={i}
                className="rounded-2xl border border-neutral-800 bg-white/5 backdrop-blur-sm p-5 hover:border-neutral-600 hover:-translate-y-0.5 transition"
              >
                <div className="flex items-start gap-3">
                  <div className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-neutral-700">
                    <img
                      src={iconSrc}
                      alt=""
                      className="h-5 w-5"
                      loading="lazy"
                      width={20}
                      height={20}
                    />
                  </div>
                  <div className="text-lg font-semibold">{s}</div>
                </div>
                <p className="mt-2 text-sm text-neutral-300">{blurb}</p>
              </div>
            );
          })}
        </div>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl md:text-3xl font-extrabold">
          {t("about.approach_title")}
        </h2>
        <div className="grid md:grid-cols-3 gap-4">
          {approachTitles.map((title, i) => (
            <div
              key={i}
              className="group rounded-2xl border border-neutral-800 bg-white/5 backdrop-blur-sm p-6 hover:border-neutral-600 transition"
            >
              <div className="mb-4 inline-flex items-center justify-center rounded-xl border border-neutral-700 text-white p-3">
                <Icon
                  name={i === 0 ? "bolt" : i === 1 ? "advisory" : "globe"}
                  className="h-6 w-6"
                />
              </div>
              <h3 className="text-lg font-bold mb-2">{title}</h3>
              <p className="text-sm text-neutral-300">
                {approachDescs[i] ||
                  (i === 0
                    ? "First shortlist in 2–3 days with zero compromise on quality or culture fit."
                    : i === 1
                    ? "Data-backed guidance on funnel health, conversion, and offers so decisions are confident."
                    : "Deep understanding of stacks, roles, and talent pools ensures targeted, relevant outreach.")}
              </p>
            </div>
          ))}
        </div>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl md:text-3xl font-extrabold">
          {t("about.facts_title")}
        </h2>
        <p className="text-neutral-300">
          We turn challenging hiring needs into success stories — from
          hard-to-fill senior roles to scaling whole teams fast, and even
          “impossible” low-budget hires.
        </p>
        <div className="grid sm:grid-cols-2 gap-4">
          {stories.map((s, i) => (
            <div
              key={i}
              className="group rounded-2xl border border-neutral-800 bg-white/5 backdrop-blur-sm p-5 hover:border-neutral-600 transition"
            >
              <div className="flex items-start gap-3">
                <div className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-neutral-700">
                  <svg
                    viewBox="0 0 24 24"
                    className="h-5 w-5 text-green-400"
                    fill="none"
                    aria-hidden="true"
                  >
                    <path
                      d="M20 7L9 18l-5-5"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <div className="space-y-2">
                  <h3 className="text-base md:text-lg font-semibold text-white">
                    {s.title}
                  </h3>
                  <div className="inline-flex items-center gap-2">
                    <span className="rounded-full bg-green-500/10 text-green-400 border border-green-500/30 px-2.5 py-1 text-xs font-semibold">
                      Result
                    </span>
                    <p className="text-sm text-neutral-300">{s.result}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl md:text-3xl font-extrabold">
          Area of Expertise
        </h2>
        <p className="text-neutral-300">
          We connect top talent across every critical function of your business.
          Our recruitment expertise includes, but is not limited to:
        </p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {expertise.map((b, i) => (
            <div
              key={i}
              className="group rounded-2xl border border-neutral-800 bg-white/5 backdrop-blur-sm p-5 hover:border-neutral-600 hover:-translate-y-0.5 transition"
            >
              <div className="flex items-start gap-3">
                <div className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-neutral-700 text-white">
                  <SmallIcon name={b.icon} />
                </div>
                <div className="space-y-1">
                  <h3 className="text-base md:text-lg font-semibold text-white">
                    {b.title}
                  </h3>
                  <p className="text-sm text-neutral-300">{b.roles}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </section>
  );
}
